export const DomainModelTransform = {
  transformBody: (context, path, data) => {
    if (
      context["transform"] !== undefined &&
      context["transform"]["request"] !== undefined &&
      (context["transform"]["request"][path] ||
        context["transform"]["request"]["default"])
    ) {
      if (
        context["transform"]["request"][path] !== undefined &&
        context["transform"]["request"][path]["body"] !== undefined
      )
        return context["transform"]["request"][path]["body"](data);
      if (
        context["transform"]["request"]["default"] !== undefined &&
        context["transform"]["request"]["default"]["body"] !== undefined
      )
        return context["transform"]["request"]["default"]["body"](data);
    }
    return data;
  },
  transformQuery: (context, path, data) => {
    if (
      context["transform"] !== undefined &&
      context["transform"]["request"] !== undefined &&
      (context["transform"]["request"][path] ||
        context["transform"]["request"]["default"])
    ) {
      if (
        context["transform"]["request"][path] !== undefined &&
        context["transform"]["request"][path]["query"] !== undefined
      ) {
        return context["transform"]["request"][path]["query"](data);
      }
      if (
        context["transform"]["request"]["default"] !== undefined &&
        context["transform"]["request"]["default"]["query"] !== undefined
      )
        return context["transform"]["request"]["default"]["query"](data);
    }
    return data;
  },
};
